import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "payment"
  }, [_c('Header'), _c('div', {
    staticClass: "content paymentcont"
  }, [_vm._m(0), _c('div', {
    staticClass: "gopay",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("返回首页")])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', [_c('i', {
    staticClass: "iconfont icontijiaochenggong"
  }), _c('h3', [_c('p', [_vm._v("订单提交成功！")]), _c('p', [_vm._v("我们会在1个工作日内和你取得联系，请保持电话畅通")])])])]);
}];
export { render, staticRenderFns };